import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/(org)/o/$orgSlug/settings")({
  validateSearch: z.object({
    tab: z
      .enum(["profiles", "members", "settings", "organizations", "history"])
      .optional()
      .catch(undefined),
  }),
});
